import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import * as R from 'ramda';
import { Button, createTheme, ThemeProvider } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';

import { PosPlugin } from 'plugins/plugin';
import Icon from 'components/Icon';

import {
  getIsMedicalEntitySelected,
  getIsSchoolEntitySelected,
  getTafReduxState,
} from '../rdx/reducers';
import {
  toggleEditMode,
  setEditState,
  resetEntityInProduct,
  setSelectedEntity,
} from '../rdx/actions';
import singlePrompt from '../utils';

const EntityRows = ({ order, isEven }) => {
  const dispatch = useDispatch();
  const { productsState } = useSelector(getTafReduxState);
  const currentProduct = productsState[order.orderIndex] ?? {};
  const hasBothEntityIDs =
    currentProduct.medicalEntity?.entityID &&
    currentProduct.schoolEntity?.entityID;

  const theme = createTheme({
    palette: {
      primary: amber,
    },
  });

  return (
    <>
      {Object.keys(currentProduct).map((key, index) => {
        const { entityID, entityName, entityType } = currentProduct[key];

        return entityID ? (
          <tr
            style={{
              cursor: 'pointer',
              borderBottom:
                hasBothEntityIDs && index === 0 ? 'none' : '1px solid white',
            }}
            className={classNames({ isEven, grouped: true })}
          >
            <td colSpan={11} style={{ borderTop: 'none' }}>
              <Icon
                style={{ marginRight: '15px' }}
                name="erply_delete_color"
                action={() =>
                  dispatch(resetEntityInProduct(order.orderIndex, entityType))
                }
              />
              <ThemeProvider theme={theme}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    dispatch(toggleEditMode(true));
                    dispatch(setSelectedEntity(entityType));
                    dispatch(singlePrompt('TafCustomerSearchModal'));
                    dispatch(
                      setEditState({
                        selectedOrderIndex: order.orderIndex,
                        newEntityType: entityType,
                      }),
                    );
                  }}
                  style={{ marginRight: '15px', padding: '0 5px' }}
                >
                  Edit
                </Button>
              </ThemeProvider>
              <span style={{ fontSize: '12px' }}>{entityName}</span>
            </td>
          </tr>
        ) : null;
      })}
    </>
  );
};

const UICustomTableBillRow: PosPlugin['UICustomTableBillRow'] = ({
  children,
  order,
  isEven,
}) => {
  const isSchoolSelected = useSelector(getIsSchoolEntitySelected);
  const isMedicalSelected = useSelector(getIsMedicalEntitySelected);

  return R.pipe(
    React.Children.toArray,
    R.when(
      () => isSchoolSelected || isMedicalSelected,
      R.insert(1, <EntityRows order={order} isEven={isEven} />),
    ),
  )(children);
};

export default UICustomTableBillRow;
